import React from 'react';
import Header from './Header';
import Footer from './Footer';

const APP_STORE_URL = 'https://apps.apple.com/us/app/hole-in-1-record-golf-shots/id6740539498';

const PremiumPage: React.FC = () => {

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative text-gray-900 py-20 mt-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-gray-900">
              Premium <span className="text-gray-900">Membership</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Pricing Plans Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold mb-4">
                <span className="text-gray-900">A plan for </span>
                <span style={{ color: '#9CB75A' }}>everyone</span>
              </h2>
              <p className="text-gray-600 text-lg">No commitment required, cancel anytime</p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 lg:gap-8 items-start">
              {/* Free Plan */}
              <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 hover:shadow-xl transition-shadow">
                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Free</h3>
                  <div className="flex items-baseline">
                    <span className="text-5xl font-bold text-gray-900">Free</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8">
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">1 shot per day</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">Home course only</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">$500 prize value</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">Social features</span>
                  </li>
                </ul>

                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-3 px-6 font-semibold rounded-xl transition-colors text-center hover:opacity-90"
                  style={{ backgroundColor: '#9CB75A', color: 'white' }}
                >
                  Get Started
                </a>
              </div>

              {/* Monthly Plan - Highlighted */}
              <div className="rounded-2xl shadow-2xl p-8 relative transform md:-translate-y-4" style={{ backgroundColor: '#9CB75A' }}>
                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-white mb-2">Premium Monthly</h3>
                  <div className="flex items-baseline">
                    <span className="text-5xl font-bold text-white">$11.99</span>
                    <span className="text-white/80 ml-2">/mo</span>
                  </div>
                </div>

                <p className="text-white/90 font-medium mb-6">All the features of free plus...</p>

                <ul className="space-y-4 mb-8">
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3 flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-white">Unlimited shots</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3 flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-white">All courses access</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3 flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-white">$3,500+ prize value</span>
                  </li>
                  {/* <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3 flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-white">Monthly raffle tickets</span>
                  </li> */}
                </ul>

                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-3 px-6 bg-white font-semibold rounded-xl transition-colors hover:bg-gray-100 text-center"
                  style={{ color: '#9CB75A' }}
                >
                  Get Started
                </a>
              </div>

              {/* Yearly Plan */}
              <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 hover:shadow-xl transition-shadow relative">
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <span className="text-white px-4 py-1 rounded-full text-sm font-medium" style={{ backgroundColor: '#9CB75A' }}>
                    BEST VALUE
                  </span>
                </div>

                <div className="mb-6 mt-2">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Premium Yearly</h3>
                  <div className="flex items-baseline">
                    <span className="text-5xl font-bold text-gray-900">$99</span>
                    <span className="text-gray-500 ml-2">/year</span>
                  </div>
                </div>

                <p className="text-gray-600 mb-6">
                  Same as monthly but save <span className="font-semibold" style={{ color: '#9CB75A' }}>$44.88</span> per year
                </p>

                <ul className="space-y-4 mb-8">
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">Only $8.25/month</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">All premium features</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5 mr-3 flex-shrink-0" style={{ backgroundColor: '#9CB75A' }}>
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-700">Billed annually</span>
                  </li>
                </ul>

                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-3 px-6 font-semibold rounded-xl transition-colors text-center hover:opacity-90"
                  style={{ backgroundColor: '#9CB75A', color: 'white' }}
                >
                  Get Started
                </a>
              </div>
            </div>

            {/* Price Comparison Section */}
            <div className="mt-20">
              <div className="text-center mb-12">
                <h3 className="text-2xl sm:text-3xl font-bold text-black mb-4">
                  For the Price of a...
                </h3>
                <div className="text-center">
                  <p className="text-lg text-gray-600 mb-2">
                    <span className="font-semibold text-black">Bucket of range balls</span> ($8-12)
                  </p>
                  <p className="text-lg text-gray-600 mb-2">
                    <span className="font-semibold text-black">Turn snack & drink</span> ($8-12)
                  </p>
                  <p className="text-lg text-gray-600">
                    <span className="font-semibold text-black">Golf cart fee</span> ($8-12)
                  </p>
                </div>
              </div>
              
              <div className="max-w-4xl mx-auto">
                <div className="text-center">
                  <p className="text-xl text-gray-700 max-w-3xl mx-auto">
                    <span className="font-semibold" style={{ color: '#9CB75A' }}>you get unlimited chances to win $3,500+ prizes</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Benefits Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-black mb-6">
                Premium Benefits
              </h2>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {/* Unlimited Shots */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#9CB75A' }}>
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-black mb-4">Unlimited Shots</h3>
                <p className="text-gray-600">
                  Free members get 1 hole-in-one attempt per day. Premium members get 1 attempt per par 3 per day with no limit to the number of par 3s you can play.
                </p>
              </div>

              {/* All Courses Access */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#9CB75A' }}>
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-black mb-4">All Courses Access</h3>
                <p className="text-gray-600">
                  Free members can only enter prizes at their home course. Premium opens up every course on the app — play wherever you want and still win.
                </p>
              </div>

              {/* Higher Prize Values */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#9CB75A' }}>
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-black mb-4">Higher Prize Values</h3>
                <p className="text-gray-600">
                  Free prizes are around $500 in value. Premium unlocks exclusive high-value prizes worth $3,500 or more at every course.
                </p>
              </div>

              {/* Double Raffle Tickets - Hidden for now */}
              {/* <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#9CB75A' }}>
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-black mb-4">Monthly Raffle Tickets</h3>
                <p className="text-gray-600">
                  Get 1 raffle ticket per shot for the monthly raffle. Win prizes even without making a hole-in-one.
                </p>
              </div> */}

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PremiumPage;
